import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

import { configuration, events, reconcileEvents, reconcileConfiguration } from './util';
import GridColumn from './GridColumn';

export interface GridProps extends KendoWidgetProps, kendo.ui.GridOptions {
    children?: React.ReactNode;
}

export default class Grid extends KendoBaseComponent<GridProps, {}> {
    private oldProps: GridProps;

    componentDidMount(): void {
        const domNode = this.domNode;
        const { _configuration: gridConfiguration, _gridEvents: gridEvents, dataSource, children } =
            this.enhanceProps(this.props);

        let options = Object.assign({}, gridConfiguration, gridEvents, { dataSource });
        const columns: kendo.ui.GridColumn[] = React.Children
            .toArray(children)
            .filter((child: React.ReactElement<any>) => child && child.type === GridColumn)
            .map((child: React.ReactElement<any>) => Object.assign({}, child.props));

        if (columns.length > 0) {
            options = Object.assign(options, { columns });
        }

        if (domNode) {
            this.widgetInstance = new kendo.ui.Grid(domNode as Element, options);
            super.componentDidMount();
        }
        this.didMount = true;
        this.oldProps = this.props;
    }

    componentDidUpdate() {
        this.oldProps = this.props;
    }

    render(): any {
        if (this.didMount) {
            const nextOptions = this.enhanceProps(this.props);
            const currentOptions = this.enhanceProps(this.oldProps);

            this.setDataSource(this.props.dataSource);

            reconcileConfiguration(currentOptions._configuration, nextOptions._configuration, this.widgetInstance);
            reconcileEvents(currentOptions._gridEvents, nextOptions._gridEvents, this.widgetInstance);
        }
        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'div' || child.type === 'table'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <div ref={this.elementRef} />;
    }

    private setDataSource(dataSource: any): void {
        if (this.widgetInstance.options.dataSource !== dataSource) {
            (this.widgetInstance as kendo.ui.Grid).setDataSource(dataSource instanceof Array ?
                new kendo.data.DataSource({ data: dataSource }) : dataSource);
        }
    }

    private enhanceProps(props: GridProps): any {
        const _configuration = Object.create(null);
        const _gridEvents = Object.create(null);

        Object.keys(props)
            .map(key => {
                if (configuration.indexOf(key) !== -1) {
                    Object.defineProperty(_configuration, key, {
                        enumerable: true,
                        value: props[key]
                    });
                } else if (events.indexOf(key) !== -1) {
                    Object.defineProperty(_gridEvents, key, {
                        enumerable: true,
                        value: props[key]
                    });
                }
            });

        return {
            _configuration,
            _gridEvents,
            ...props
        };
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-react-wrapper/src/grid/index.tsx